import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-74902a52"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "My-ECharts"
};

var _hoisted_2 = /*#__PURE__*/_createStaticVNode("<span class=\"left-top\" data-v-74902a52></span><span class=\"left-bottom\" data-v-74902a52></span><span class=\"right-top\" data-v-74902a52></span><span class=\"right-bottom\" data-v-74902a52></span><div class=\"top\" data-v-74902a52><div class=\"left\" data-v-74902a52><div class=\"line\" data-v-74902a52></div><div class=\"title\" data-v-74902a52> 民主评议 </div></div></div>", 5);

var _hoisted_7 = {
  id: "democracyMain",
  ref: "eCharts",
  style: {
    "width": "100%",
    "height": "97%",
    "display": "flex",
    "align-items": "end"
  },
  class: "echarts-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_7, null, 512)]);
}